/**
 * aerobis GWP (product-only live):
 * - Product gifts: Cart Transform under the parent line
 * - Cart free gifts + free tiers: OFF
 * Strip leftover threshold claim lines. Never add claims. Never cart:refresh for GWP.
 */
(function () {
  if (window.aerobisGwpCartTiers) return;

  var ATTR = "_gwp_gloves_size";
  var ANCHOR_PROP = "_gwp_anchor";
  var ANCHOR_SKU = "GWP-ANCHOR";
  var ANCHOR_HANDLE = "gwp-threshold-anchor";
  // Anchor auto-add stays off (0). Leftover anchors still strip by handle/sku.
  // Disabled auto-add while threshold expands onto qty1 paid merch (test-21).
  // Keep SKU/handle detection so leftover anchors still hide/remove.
  var GWP_ANCHOR_VARIANT_ID = 0;
  var GLOVES_EUR = 200;
  var MASK_EUR = 300;
  var CLAIM_PROP = "_gwp_threshold_claim";
  var GIFT_PROP = "_gwp_gift";
  var GLOVES_VID_FALLBACK = {
    S: 56297004466525,
    M: 56297004532061,
    L: 56297004564829,
    XL: 56297004499293
  };
  var MASK_VID_FALLBACK = 65347959161181;
  var GLOVES_HANDLE = "aerobis-fitness-training-gloves";
  var MASK_HANDLE = "sleep-mask-100-blackout-memory-foam";
  var SIZES = { S: true, M: true, L: true, XL: true };
  var MARK_RANK = { gloves: 1, mask: 2, ship: 3 };
  var FS_FRINGE = "AC,BR,IO,VG,CV,FK,TF,GG,IQ,LY,YT,NU,PN,RU,MF,ST,SO,GS,SS,SH,PM,SD,SJ,TL,TK,TA,TM,TC,TV,UM,VA,WF,EH,SX".split(",");
  var FS_EU = "AT,BE,BG,HR,CY,CZ,DK,EE,FI,FR,GR,HU,IE,IT,LV,LT,LU,MT,NL,PL,PT,RO,SK,SI,ES,SE".split(",");
  var lastSubtotalCents = null;
  var lastTotalCents = null;
  var defaultWriteStarted = false;
  var sizeWriteInFlight = false;
  var anchorInFlight = false;
  var claimInFlight = false;
  var lastAnchorKey = "";
  var timers = [];

  function shopifyCurrency() {
    var shopify = window.Shopify;
    return (shopify && shopify.currency) || {};
  }

  function cartRoot() {
    var shopify = window.Shopify;
    return (shopify && shopify.routes && shopify.routes.root) || "/";
  }

  function money(amount, currency) {
    var whole = Math.round(amount);
    if (currency === "EUR") {
      var fmt = (window.themeVariables && themeVariables.settings && themeVariables.settings.moneyFormat) || "";
      if (fmt) {
        return fmt
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, String(whole))
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(whole))
          .replace(/\{\{\s*amount\s*\}\}/g, whole.toFixed(2));
      }
      return whole + "\u20ac";
    }
    try {
      return new Intl.NumberFormat((window.Shopify && window.Shopify.locale) || undefined, {
        style: "currency",
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(whole);
    } catch (e) {
      return whole + " " + currency;
    }
  }

  function resolveRate(el) {
    var shopifyCur = shopifyCurrency();
    var rate = parseFloat(shopifyCur.rate);
    var active = shopifyCur.active || "";
    var currency = active || (el && el.getAttribute("data-gwp-currency")) || "";
    if (!currency) currency = (el && el.getAttribute("data-gwp-shop-currency")) || "EUR";
    var useRate = rate;
    if (!(useRate > 0)) useRate = 1;
    return { useRate: useRate, currency: currency };
  }

  function subtotalFromCart(cart) {
    if (!cart || cart.items_subtotal_price == null) return null;
    var n = parseInt(cart.items_subtotal_price, 10);
    return isNaN(n) ? null : n;
  }

  function totalFromCart(cart) {
    if (!cart || cart.total_price == null) return null;
    var n = parseInt(cart.total_price, 10);
    return isNaN(n) ? null : n;
  }

  function normalizeSize(value) {
    var size = String(value || "").toUpperCase().trim();
    return SIZES[size] ? size : "M";
  }

  function shipGateEur(iso) {
    var code = String(iso || "").toUpperCase().trim();
    if (!code) return 0;
    if (FS_FRINGE.indexOf(code) !== -1) return 0;
    if (code === "DE") return 50;
    if (code === "US" || code === "CA" || code === "CH" || code === "GB") return 300;
    if (FS_EU.indexOf(code) !== -1) return 200;
    return 0;
  }

  function clampPct(n) {
    if (n < 0) return 0;
    if (n > 100) return 100;
    return n;
  }

  function placeMarks(items, endEur) {
    var list = (items || []).slice().sort(function (a, b) {
      if (a.eur !== b.eur) return a.eur - b.eur;
      return (MARK_RANK[a.key] || 9) - (MARK_RANK[b.key] || 9);
    });
    var out = {};
    var i;
    for (i = 0; i < list.length; i++) {
      var pct = endEur > 0 ? (list[i].eur / endEur) * 100 : 0;
      out[list[i].key] = { pct: clampPct(pct), eur: list[i].eur };
    }
    for (i = 1; i < list.length; i++) {
      var prev = out[list[i - 1].key];
      var cur = out[list[i].key];
      if (Math.abs(cur.pct - prev.pct) < 14) {
        prev.pct = clampPct(prev.pct - 7);
        cur.pct = clampPct(cur.pct + 7);
      }
    }
    return out;
  }

  function remainEur(gate, current) {
    var n = gate - current;
    return n > 0 ? n : 0;
  }

  function resolveState(opts) {
    var glovesEur = Number(opts.glovesEur) || 200;
    var maskEur = Number(opts.maskEur) || 300;
    var shipEur = Number(opts.shipEur);
    if (!(shipEur > 0)) shipEur = 0;
    var rate = Number(opts.rate) || 1;
    var cents = parseInt(opts.subtotalCents, 10);
    if (isNaN(cents) || cents < 0) cents = 0;
    var shopEur = cents / 100 / rate;
    var glovesOk = opts.glovesAvailable !== false;
    var maskOk = opts.maskAvailable !== false;
    var shipOk = shipEur > 0;
    var glovesUnlocked = glovesOk && shopEur + 1e-9 >= glovesEur;
    var maskUnlocked = maskOk && shopEur + 1e-9 >= maskEur;
    var shipCents = opts.totalCents;
    if (shipCents == null || shipCents === "") shipCents = cents;
    shipCents = parseInt(shipCents, 10);
    if (isNaN(shipCents) || shipCents < 0) shipCents = 0;
    var shipShopEur = shipCents / 100 / rate;
    var shipUnlocked = shipOk && shipShopEur + 1e-9 >= shipEur;
    var progressKey = "";
    var remainingEur = 0;
    if (glovesOk && !glovesUnlocked) {
      progressKey = "gloves";
      remainingEur = remainEur(glovesEur, shopEur);
    } else if (maskOk && !maskUnlocked && (glovesUnlocked || !glovesOk)) {
      progressKey = "mask";
      remainingEur = remainEur(maskEur, shopEur);
    } else if (shipOk && !shipUnlocked) {
      progressKey = "ship";
      remainingEur = remainEur(shipEur, shipShopEur);
    }
    var endEur = 0;
    if (glovesOk) endEur = Math.max(endEur, glovesEur);
    if (maskOk) endEur = Math.max(endEur, maskEur);
    if (shipOk) endEur = Math.max(endEur, shipEur);
    if (!(endEur > 0)) endEur = 300;
    // Fill must reflect ship progress too. Gift SKUs are excluded from shopEur,
    // so gloves-only carts had fill 0% while free-ship was already unlocked.
    var fillBasisEur = shopEur;
    if (shipOk && shipShopEur > fillBasisEur) fillBasisEur = shipShopEur;
    var fillPct = clampPct((fillBasisEur / endEur) * 100);
    var marks = [];
    if (shipOk) marks.push({ key: "ship", eur: shipEur });
    if (glovesOk) marks.push({ key: "gloves", eur: glovesEur });
    if (maskOk) marks.push({ key: "mask", eur: maskEur });
    var placed = placeMarks(marks, endEur);
    return {
      shopEur: shopEur,
      shipShopEur: shipShopEur,
      glovesUnlocked: glovesUnlocked,
      maskUnlocked: maskUnlocked,
      shipUnlocked: shipUnlocked,
      showGloves: glovesUnlocked,
      showMask: maskUnlocked,
      progressKey: progressKey,
      remainingEur: remainingEur,
      glovesRemainEur: glovesOk ? remainEur(glovesEur, shopEur) : 0,
      maskRemainEur: maskOk ? remainEur(maskEur, shopEur) : 0,
      shipRemainEur: shipOk ? remainEur(shipEur, shipShopEur) : 0,
      endEur: endEur,
      fillPct: fillPct,
      glovesMarkPct: placed.gloves ? placed.gloves.pct : 0,
      maskMarkPct: placed.mask ? placed.mask.pct : 0,
      shipMarkPct: placed.ship ? placed.ship.pct : 0,
      glovesAvailable: glovesOk,
      maskAvailable: maskOk,
      shipAvailable: shipOk
    };
  }

  function setHidden(el, hidden) {
    if (!el) return;
    if (hidden) el.setAttribute("hidden", "");
    else el.removeAttribute("hidden");
  }

  function fillTemplate(tmpl, amount) {
    return String(tmpl || "__AMT__").replace(/__AMT__/g, amount);
  }

  function layoutMarks(items, trackWidth, iconSize) {
    var width = trackWidth > 0 ? trackWidth : 320;
    var size = iconSize > 0 ? iconSize : 48;
    var insetPct = Math.min(18, (size / 2 / width) * 100);
    var minGapPct = (size / width) * 100;
    var list = (items || []).slice().sort(function (a, b) {
      if (a.pct !== b.pct) return a.pct - b.pct;
      return (MARK_RANK[a.key] || 9) - (MARK_RANK[b.key] || 9);
    });
    var out = {};
    var i;
    for (i = 0; i < list.length; i++) {
      out[list[i].key] = {
        pct: clampPct(Math.max(insetPct, Math.min(100 - insetPct, list[i].pct))),
        wrap: false
      };
    }
    for (i = 1; i < list.length; i++) {
      var prev = out[list[i - 1].key];
      var cur = out[list[i].key];
      if (Math.abs(cur.pct - prev.pct) < minGapPct) {
        cur.wrap = true;
      }
    }
    return out;
  }

  function paintMarker(root, key, pct, available, unlocked, wrap) {
    var mark = root.querySelector('[data-gwp-mark="' + key + '"]');
    if (!mark) return;
    mark.style.left = pct + "%";
    mark.classList.toggle("is-lit", !!unlocked);
    mark.classList.toggle("is-wrap", !!wrap);
    setHidden(mark, !available);
  }

  function remainTextEl(el) {
    if (!el) return null;
    return el.querySelector("[data-gwp-remain-text]") || el;
  }

  function paintRemain(root, key, available, unlocked, amountText) {
    var el = root.querySelector('[data-gwp-remain="' + key + '"]');
    if (!el) return;
    var tmpl = root.getAttribute("data-gwp-progress-" + key) || "";
    var textEl = remainTextEl(el);
    if (tmpl && textEl) textEl.textContent = fillTemplate(tmpl, amountText);
    el.classList.toggle("is-done", !!unlocked);
    // Keep unlocked remain lines visible (struck via is-done). Size picker stays its own row.
    setHidden(el, !available);
  }


  function itemSku(item) {
    return String((item && item.sku) || "").trim();
  }

  function itemHandle(item) {
    if (!item) return "";
    if (item.handle) return String(item.handle).trim().toLowerCase();
    if (item.product_handle) return String(item.product_handle).trim().toLowerCase();
    return "";
  }

  function itemProps(item) {
    return (item && item.properties) || {};
  }

  function itemLineCents(item) {
    var price = item && (item.final_line_price != null ? item.final_line_price : item.line_price);
    var n = parseInt(price, 10);
    return isNaN(n) ? 0 : n;
  }

  function parseVariantId(value) {
    if (value == null) return 0;
    var s = String(value).trim();
    if (!s || s.indexOf("REPLACE_ME") !== -1) return 0;
    var gid = s.match(/ProductVariant\/(\d+)/);
    if (gid) return parseInt(gid[1], 10) || 0;
    var n = parseInt(s, 10);
    return n > 0 ? n : 0;
  }

  function resolveAnchorVariantId() {
    var cfg = window.aerobisGwp || {};
    var fromCfg = parseVariantId(cfg.anchorVariantId || cfg.GWP_ANCHOR_VARIANT_ID);
    if (fromCfg) return fromCfg;
    return parseVariantId(GWP_ANCHOR_VARIANT_ID);
  }

  function isFreeGiftItem(item) {
    if (!item) return false;
    return itemLineCents(item) === 0;
  }

  // Match Function merchandise_subtotal_excluding_gifts: paid gloves/mask
  // do not unlock threshold tiers (only non-gift merch counts).
  function isThresholdGiftSkuItem(item) {
    if (!item) return false;
    var sku = itemSku(item).toUpperCase();
    if (sku.indexOf("000836") === 0) return true;
    if (sku === "000860") return true;
    var handle = itemHandle(item);
    if (handle === "aerobis-fitness-training-gloves" || handle === "training-gloves") return true;
    if (handle === "sleep-mask-100-blackout-memory-foam") return true;
    return false;
  }

  function isGwpAnchorItem(item) {
    if (!item) return false;
    var props = itemProps(item);
    if (String(props[ANCHOR_PROP] || "").trim() === "1") return true;
    var sku = itemSku(item).toUpperCase();
    if (sku === ANCHOR_SKU || sku.indexOf(ANCHOR_SKU + ".") === 0) return true;
    if (itemHandle(item) === ANCHOR_HANDLE) return true;
    var configured = resolveAnchorVariantId();
    var vid = parseVariantId(item.variant_id || item.id);
    return !!(configured && vid && vid === configured);
  }

  function collectAnchors(items) {
    var out = [];
    var list = items || [];
    var i;
    for (i = 0; i < list.length; i++) {
      if (isGwpAnchorItem(list[i])) out.push(list[i]);
    }
    return out;
  }

  function merchandiseSubtotalCents(cart) {
    if (!cart) return null;
    if (cart.items && cart.items.length) {
      var sum = 0;
      var i;
      for (i = 0; i < cart.items.length; i++) {
        var it = cart.items[i];
        if (isGwpAnchorItem(it) || isFreeGiftItem(it) || isThresholdGiftSkuItem(it)) continue;
        sum += itemLineCents(it);
      }
      return sum;
    }
    return subtotalFromCart(cart);
  }

  function shopEurFromCart(cart, rate) {
    var cents = merchandiseSubtotalCents(cart);
    if (cents == null) return null;
    var useRate = rate > 0 ? rate : 1;
    return cents / 100 / useRate;
  }

  function cartStateKey(cart) {
    if (!cart || !cart.items) return "";
    return cart.items
      .map(function (it) {
        return String(it.key || it.id) + ":" + String(it.quantity) + ":" + String(it.variant_id || it.id);
      })
      .join("|");
  }

  function postJson(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error("cart ajax " + r.status);
      return r.json();
    });
  }

  function fetchCart() {
    return fetch(cartRoot() + "cart.js", {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    }).then(function (r) {
      return r.json();
    });
  }

  function bundledSections() {
    var sections = [];
    try {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: sections }
        })
      );
    } catch (e) {}
    return sections;
  }

  function sectionsUrl() {
    try {
      if (window.location && window.location.pathname) return window.location.pathname;
    } catch (e) {}
    return cartRoot() + "cart";
  }

  function withSections(body) {
    var sections = bundledSections();
    if (sections && sections.length) {
      body.sections = sections;
      body.sections_url = sectionsUrl();
    }
    return body;
  }

  function refreshDrawerForCt() {
    // Impact cart:refresh re-fetches section HTML (includes item_components).
    document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
  }

  function changeAnchorLine(item, quantity) {
    var lineKey = item && item.key;
    if (!lineKey) return Promise.resolve(null);
    var body = { id: lineKey, quantity: quantity };
    if (quantity > 0) {
      var props = {};
      var src = itemProps(item);
      var key;
      for (key in src) {
        if (Object.prototype.hasOwnProperty.call(src, key)) props[key] = src[key];
      }
      props[ANCHOR_PROP] = "1";
      body.properties = props;
    }
    return postJson(cartRoot() + "cart/change.js", body);
  }

  function addAnchorLine(variantId) {
    return postJson(cartRoot() + "cart/add.js", {
      items: [
        {
          id: variantId,
          quantity: 1,
          properties: { _gwp_anchor: "1" }
        }
      ]
    }).then(function () {
      return fetchCart();
    });
  }

  function planAnchorSync(cart, rate) {
    var shopEur = shopEurFromCart(cart, rate);
    var anchors = collectAnchors(cart && cart.items);
    var variantId = resolveAnchorVariantId();
    if (shopEur == null) {
      return { action: "none", shopEur: shopEur, anchors: anchors, variantId: variantId };
    }
    // Auto-add disabled (variantId 0): strip leftover GWP-ANCHOR lines.
    if (!variantId) {
      if (anchors.length) {
        return { action: "remove", shopEur: shopEur, anchors: anchors, variantId: variantId };
      }
      return { action: "none", shopEur: shopEur, anchors: anchors, variantId: variantId };
    }
    if (shopEur + 1e-9 >= GLOVES_EUR) {
      if (!anchors.length) {
        return {
          action: variantId ? "add" : "none",
          shopEur: shopEur,
          anchors: anchors,
          variantId: variantId
        };
      }
      var keep = anchors[0];
      var extras = anchors.slice(1);
      var needQty = keep.quantity !== 1;
      var needProp = String(itemProps(keep)[ANCHOR_PROP] || "").trim() !== "1";
      if (needQty || needProp || extras.length) {
        return {
          action: "repair",
          shopEur: shopEur,
          anchors: anchors,
          keep: keep,
          extras: extras,
          variantId: variantId
        };
      }
      return { action: "none", shopEur: shopEur, anchors: anchors, variantId: variantId };
    }
    if (anchors.length) {
      return { action: "remove", shopEur: shopEur, anchors: anchors, variantId: variantId };
    }
    return { action: "none", shopEur: shopEur, anchors: anchors, variantId: variantId };
  }

  function runAnchorPlan(plan) {
    if (!plan || plan.action === "none") return Promise.resolve(null);
    if (plan.action === "add") return addAnchorLine(plan.variantId);
    var chain = Promise.resolve(null);
    if (plan.action === "repair") {
      if (plan.keep) chain = chain.then(function () { return changeAnchorLine(plan.keep, 1); });
      (plan.extras || []).forEach(function (extra) {
        chain = chain.then(function () { return changeAnchorLine(extra, 0); });
      });
      return chain.then(function () { return fetchCart(); });
    }
    if (plan.action === "remove") {
      (plan.anchors || []).forEach(function (anchor) {
        chain = chain.then(function () { return changeAnchorLine(anchor, 0); });
      });
      return chain.then(function () { return fetchCart(); });
    }
    return Promise.resolve(null);
  }

  function maybeSyncAnchor(cart) {
    if (anchorInFlight || sizeWriteInFlight || claimInFlight) return Promise.resolve(cart || null);
    if (!cart || !cart.items) return Promise.resolve(cart || null);
    var rate = parseFloat(shopifyCurrency().rate) || 1;
    var plan = planAnchorSync(cart, rate);
    if (plan.action === "none") return Promise.resolve(cart || null);
    var stateKey = cartStateKey(cart) + ":" + plan.action;
    if (stateKey && stateKey === lastAnchorKey) return Promise.resolve(cart || null);
    anchorInFlight = true;
    lastAnchorKey = stateKey;
    return runAnchorPlan(plan)
      .then(function (nextCart) {
        anchorInFlight = false;
        if (!nextCart) return cart || null;
        document.dispatchEvent(
          new CustomEvent("cart:refresh", { bubbles: true, detail: { cart: nextCart } })
        );
        return nextCart;
      })
      .catch(function () {
        anchorInFlight = false;
        return cart || null;
      });
  }

  function isGlovesItem(item) {
    if (!item) return false;
    var sku = itemSku(item).toUpperCase();
    if (sku.indexOf("000836") === 0) return true;
    var handle = itemHandle(item);
    return handle === GLOVES_HANDLE || handle === "training-gloves";
  }

  function isMaskItem(item) {
    if (!item) return false;
    var sku = itemSku(item).toUpperCase();
    if (sku === "000860") return true;
    return itemHandle(item) === MASK_HANDLE;
  }

  function isClaimItem(item, giftKey) {
    if (!item) return false;
    var props = itemProps(item);
    if (String(props[CLAIM_PROP] || "").trim() !== "1") return false;
    if (!giftKey) return true;
    return String(props[GIFT_PROP] || "").trim() === giftKey;
  }

  function hasFreeGloves(items) {
    var list = items || [];
    var i;
    for (i = 0; i < list.length; i++) {
      if (isGwpAnchorItem(list[i])) continue;
      if (isGlovesItem(list[i]) && itemLineCents(list[i]) === 0) return true;
    }
    return false;
  }

  function hasFreeMask(items) {
    var list = items || [];
    var i;
    for (i = 0; i < list.length; i++) {
      if (isGwpAnchorItem(list[i])) continue;
      if (isMaskItem(list[i]) && itemLineCents(list[i]) === 0) return true;
    }
    return false;
  }



  function readGlovesSize(cart) {
    var attrs = (cart && cart.attributes) || {};
    var fromAttr = normalizeSize(attrs[ATTR] || attrs._gwp_gloves_size);
    var root = document.querySelector("[data-gwp-cart-tiers]");
    if (root) {
      var fromData = (root.getAttribute("data-gwp-gloves-size") || "").trim();
      if (fromData) return normalizeSize(fromData);
      var select = root.querySelector("[data-gwp-gloves-size]");
      if (select && select.value) return normalizeSize(select.value);
    }
    return fromAttr;
  }







  function collectClaims(items, giftKey) {
    var out = [];
    var list = items || [];
    var i;
    for (i = 0; i < list.length; i++) {
      if (isClaimItem(list[i], giftKey)) out.push(list[i]);
    }
    return out;
  }

  function glovesVariantMapFromDom() {
    var root = document.querySelector("[data-gwp-cart-tiers]");
    var map = {
      S: GLOVES_VID_FALLBACK.S,
      M: GLOVES_VID_FALLBACK.M,
      L: GLOVES_VID_FALLBACK.L,
      XL: GLOVES_VID_FALLBACK.XL
    };
    if (!root) return map;
    var s = parseVariantId(root.getAttribute("data-gwp-gloves-vid-s"));
    var m = parseVariantId(root.getAttribute("data-gwp-gloves-vid-m"));
    var l = parseVariantId(root.getAttribute("data-gwp-gloves-vid-l"));
    var xl = parseVariantId(root.getAttribute("data-gwp-gloves-vid-xl"));
    if (s) map.S = s;
    if (m) map.M = m;
    if (l) map.L = l;
    if (xl) map.XL = xl;
    return map;
  }

  function resolveGlovesClaimVariantId(size) {
    var map = glovesVariantMapFromDom();
    var key = normalizeSize(size);
    return parseVariantId(map[key] || map.M || 0);
  }

  function resolveMaskClaimVariantId() {
    var root = document.querySelector("[data-gwp-cart-tiers]");
    var fromDom = root ? parseVariantId(root.getAttribute("data-gwp-mask-vid")) : 0;
    if (fromDom) return fromDom;
    return parseVariantId(MASK_VID_FALLBACK);
  }

  function changeClaimLine(item, quantity) {
    var lineKey = item && item.key;
    if (!lineKey) return Promise.resolve(null);
    return postJson(cartRoot() + "cart/change.js", {
      id: lineKey,
      quantity: quantity,
      sections_url: window.location.pathname
    });
  }

  function addClaimLine(variantId, giftKey) {
    var props = {};
    props[CLAIM_PROP] = "1";
    props[GIFT_PROP] = giftKey;
    return postJson(cartRoot() + "cart/add.js", {
      items: [{ id: variantId, quantity: 1, properties: props }],
      sections_url: window.location.pathname
    });
  }

  // Threshold gloves/mask only. Product gifts stay Cart Transform.
  // Independent of product qty so revvll 1->2 cannot wipe gloves/mask.
  function planClaimSync(cart, rate) {
    // Cart free gifts OFF: remove leftover claim lines only. Never add.
    var items = (cart && cart.items) || [];
    var ops = [];
    collectClaims(items, "gloves").forEach(function (it) { ops.push({ type: "remove", item: it }); });
    collectClaims(items, "mask").forEach(function (it) { ops.push({ type: "remove", item: it }); });
    // Any other threshold/claim props
    items.forEach(function (it) {
      var props = it.properties || {};
      if (props._gwp_threshold_claim == "1" || props._gwp_claim == "1" || props._gwp_gift) {
        var already = ops.some(function (op) { return op.type === "remove" && op.item && op.item.key === it.key; });
        if (!already) ops.push({ type: "remove", item: it });
      }
    });
    return ops;
  }

  function runClaimPlan(plan) {
    var chain = Promise.resolve(null);
    (plan || []).forEach(function (op) {
      chain = chain.then(function () {
        if (op.type === "add") return addClaimLine(op.variantId, op.giftKey);
        if (op.type === "remove") return changeClaimLine(op.item, 0);
        return null;
      });
    });
    return chain.then(function () { return fetchCart(); });
  }

  function ensureFreeGiftsList() {
    var existing = document.querySelector("[data-gwp-free-gifts] .gwp-free-gifts__list");
    if (existing) return existing;
    var host =
      document.querySelector(".cart-drawer__line-items") ||
      document.querySelector(".cart-drawer__inner .v-stack") ||
      document.querySelector("#main-cart") ||
      document.querySelector("form[action$='/cart']");
    if (!host) return null;
    var wrap = document.createElement("div");
    wrap.className = "gwp-free-gifts";
    wrap.setAttribute("data-gwp-free-gifts", "");
    var title = document.createElement("p");
    title.className = "gwp-free-gifts__title";
    title.textContent = "Free Gifts";
    var list = document.createElement("ul");
    list.className = "gwp-free-gifts__list";
    list.setAttribute("role", "list");
    wrap.appendChild(title);
    wrap.appendChild(list);
    if (host.classList && host.classList.contains("cart-drawer__line-items") && host.parentNode) {
      host.parentNode.insertBefore(wrap, host.nextSibling);
    } else {
      host.appendChild(wrap);
    }
    return list;
  }

  function claimRowId(item) {
    return "gwp-claim-" + String((item && (item.key || item.id)) || "");
  }

  // Paint claim lines into Free Gifts without cart:refresh (refresh drops CT carabiner).
  function syncClaimRowsInDom(cart) {
    var list = ensureFreeGiftsList();
    if (!list) return;
    var items = (cart && cart.items) || [];
    var claims = [];
    var i;
    for (i = 0; i < items.length; i++) {
      if (isClaimItem(items[i], null)) claims.push(items[i]);
    }
    var keep = {};
    claims.forEach(function (it) {
      var id = claimRowId(it);
      keep[id] = true;
      var row = document.getElementById(id);
      var title = (it.product_title || it.title || "Gift").trim();
      var qty = it.quantity || 1;
      if (!row) {
        row = document.createElement("li");
        row.className = "line-item gwp-free-gift-row";
        row.id = id;
        row.setAttribute("data-gwp-free-gift", "");
        row.setAttribute("data-gwp-claim-row", "1");
        row.innerHTML =
          '<div class="line-item__info"><div class="v-stack gap-0.5"><p class="bold"></p></div>' +
          '<div class="h-stack gap-3 text-sm text-subdued"><span data-gwp-claim-qty></span></div></div>';
        list.appendChild(row);
      }
      var titleEl = row.querySelector(".bold");
      if (titleEl) titleEl.textContent = title;
      var qtyEl = row.querySelector("[data-gwp-claim-qty]");
      if (qtyEl) qtyEl.textContent = "Qty: " + qty;
    });
    Array.prototype.slice.call(list.querySelectorAll("[data-gwp-claim-row]")).forEach(function (row) {
      if (!keep[row.id]) row.parentNode.removeChild(row);
    });
    var wrap = list.closest("[data-gwp-free-gifts]");
    if (wrap) {
      var hasRows = list.children.length > 0;
      wrap.hidden = !hasRows;
    }
  }

  function maybeSyncClaim(cart) {
    if (claimInFlight || anchorInFlight || sizeWriteInFlight) return Promise.resolve(cart || null);
    if (!cart || !cart.items) return Promise.resolve(cart || null);
    var rate = parseFloat(shopifyCurrency().rate) || 1;
    var plan = planClaimSync(cart, rate);
    if (!plan.length) return Promise.resolve(cart);
    claimInFlight = true;
    return runClaimPlan(plan)
      .then(function (next) {
        claimInFlight = false;
        return next || cart;
      })
      .catch(function () {
        claimInFlight = false;
        return cart;
      });
  }

  function paintRoot(root, subtotalCents, totalCents) {
    return; // cart free tiers OFF
    if (!root) return;
    var resolved = resolveRate(root);
    var useCents = subtotalCents;
    if (useCents == null) useCents = parseInt(root.getAttribute("data-gwp-subtotal-cents") || "0", 10);
    if (isNaN(useCents)) useCents = 0;
    root.setAttribute("data-gwp-subtotal-cents", String(useCents));
    var useTotal = totalCents;
    if (useTotal == null) useTotal = parseInt(root.getAttribute("data-gwp-total-cents") || String(useCents), 10);
    if (isNaN(useTotal)) useTotal = useCents;
    root.setAttribute("data-gwp-total-cents", String(useTotal));
    if (!resolved) return;

    var shipEur = parseFloat(root.getAttribute("data-gwp-ship-eur"));
    if (isNaN(shipEur)) shipEur = shipGateEur(root.getAttribute("data-gwp-ship-iso"));

    var state = resolveState({
      subtotalCents: useCents,
      totalCents: useTotal,
      rate: resolved.useRate,
      glovesEur: parseFloat(root.getAttribute("data-gwp-gloves-eur") || "200"),
      maskEur: parseFloat(root.getAttribute("data-gwp-mask-eur") || "300"),
      shipEur: shipEur,
      glovesAvailable: root.getAttribute("data-gwp-gloves-available") !== "false",
      maskAvailable: root.getAttribute("data-gwp-mask-available") !== "false",
      glovesInCart: root.getAttribute("data-gwp-gloves-in-cart") === "true",
      maskInCart: root.getAttribute("data-gwp-mask-in-cart") === "true"
    });

    root.setAttribute("data-gwp-gloves-unlocked", state.glovesUnlocked ? "true" : "false");
    root.setAttribute("data-gwp-mask-unlocked", state.maskUnlocked ? "true" : "false");
    root.setAttribute("data-gwp-ship-unlocked", state.shipUnlocked ? "true" : "false");
    root.setAttribute("data-gwp-end-eur", String(state.endEur));

    var glovesAmt = money(state.glovesRemainEur * resolved.useRate, resolved.currency);
    var maskAmt = money(state.maskRemainEur * resolved.useRate, resolved.currency);
    var shipAmt = money(state.shipRemainEur * resolved.useRate, resolved.currency);
    paintRemain(root, "gloves", state.glovesAvailable, state.glovesUnlocked, glovesAmt);
    paintRemain(root, "mask", state.maskAvailable, state.maskUnlocked, maskAmt);
    paintRemain(root, "ship", state.shipAvailable, state.shipUnlocked, shipAmt);

    var ariaParts = [];
    var glovesLine = root.querySelector('[data-gwp-remain="gloves"]');
    var maskLine = root.querySelector('[data-gwp-remain="mask"]');
    var shipLine = root.querySelector('[data-gwp-remain="ship"]');
    var glovesText = remainTextEl(glovesLine);
    var maskText = remainTextEl(maskLine);
    var shipText = remainTextEl(shipLine);
    if (state.glovesAvailable && glovesText && glovesText.textContent) ariaParts.push(glovesText.textContent);
    if (state.maskAvailable && maskText && maskText.textContent) ariaParts.push(maskText.textContent);
    if (state.shipAvailable && shipText && shipText.textContent) ariaParts.push(shipText.textContent);
    var lineText = ariaParts.join(" / ");

    var fill = root.querySelector("[data-gwp-fill]");
    var track = root.querySelector("[data-gwp-track]");
    if (fill) fill.style.width = state.fillPct + "%";
    if (track) {
      track.setAttribute("aria-valuenow", String(Math.round(state.fillPct)));
      if (lineText) track.setAttribute("aria-valuetext", lineText);
      else track.removeAttribute("aria-valuetext");
    }

    var placedKeys = [];
    if (state.shipAvailable) placedKeys.push({ key: "ship", pct: state.shipMarkPct });
    if (state.glovesAvailable) placedKeys.push({ key: "gloves", pct: state.glovesMarkPct });
    if (state.maskAvailable) placedKeys.push({ key: "mask", pct: state.maskMarkPct });
    var trackWidth = track && (track.clientWidth || track.offsetWidth) || 0;
    var iconSize = 48;
    var sampleMark = root.querySelector("[data-gwp-mark]");
    if (sampleMark && sampleMark.offsetWidth) iconSize = sampleMark.offsetWidth;
    var laid = layoutMarks(placedKeys, trackWidth, iconSize);
    var anyWrap = false;
    var glovesLaid = laid.gloves || { pct: state.glovesMarkPct, wrap: false };
    var maskLaid = laid.mask || { pct: state.maskMarkPct, wrap: false };
    var shipLaid = laid.ship || { pct: state.shipMarkPct, wrap: false };
    if (glovesLaid.wrap || maskLaid.wrap || shipLaid.wrap) anyWrap = true;
    var bar = root.querySelector("[data-gwp-bar]");
    if (bar) bar.classList.toggle("is-wrap", anyWrap);
    paintMarker(root, "gloves", glovesLaid.pct, state.glovesAvailable, state.glovesUnlocked, glovesLaid.wrap);
    paintMarker(root, "mask", maskLaid.pct, state.maskAvailable, state.maskUnlocked, maskLaid.wrap);
    paintMarker(root, "ship", shipLaid.pct, state.shipAvailable, state.shipUnlocked, shipLaid.wrap);

    // Size picker always visible while gloves tier is shown (Elmar 10 Sep 2026).
    var sizeLabel = root.querySelector("[data-gwp-size]");
    setHidden(sizeLabel, !state.glovesAvailable);
  }

  function paintAll(cart) {
    var cents = merchandiseSubtotalCents(cart);
    if (cents != null) lastSubtotalCents = cents;
    var total = totalFromCart(cart);
    if (total != null) {
      lastTotalCents = total;
      if (cart && cart.items) {
        var i;
        var minus = 0;
        for (i = 0; i < cart.items.length; i++) {
          if (isGwpAnchorItem(cart.items[i])) minus += itemLineCents(cart.items[i]);
        }
        lastTotalCents = Math.max(0, lastTotalCents - minus);
      }
    }
    var roots = document.querySelectorAll("[data-gwp-cart-tiers]");
    for (var i = 0; i < roots.length; i++) {
      var useCents = lastSubtotalCents;
      if (useCents == null) useCents = parseInt(roots[i].getAttribute("data-gwp-subtotal-cents") || "0", 10);
      var useTotal = lastTotalCents;
      if (useTotal == null) useTotal = parseInt(roots[i].getAttribute("data-gwp-total-cents") || String(useCents), 10);
      paintRoot(roots[i], useCents, useTotal);
    }
    ensureDefaultSize();
  }

  function clearTimers() {
    for (var i = 0; i < timers.length; i++) clearTimeout(timers[i]);
    timers = [];
  }

  function schedulePaint(cart) {
    paintAll(cart);
    if (cart && cart.items && !claimInFlight && !anchorInFlight) {
      maybeSyncAnchor(cart).then(function (afterAnchor) {
        return maybeSyncClaim(afterAnchor || cart);
      });
    }
    clearTimers();
    timers.push(setTimeout(function () { paintAll(cart); }, 0));
    timers.push(setTimeout(function () { paintAll(cart); }, 60));
    timers.push(setTimeout(function () { paintAll(cart); }, 1300));
  }

  function writeSize(size, refreshAfter) {
    var next = normalizeSize(size);
    if (sizeWriteInFlight) return Promise.resolve(null);
    sizeWriteInFlight = true;
    return fetch(cartRoot() + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      keepalive: true,
      body: JSON.stringify({ attributes: { _gwp_gloves_size: next } })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        sizeWriteInFlight = false;
        var roots = document.querySelectorAll("[data-gwp-cart-tiers]");
        for (var i = 0; i < roots.length; i++) {
          roots[i].setAttribute("data-gwp-gloves-size", next);
          var select = roots[i].querySelector("[data-gwp-gloves-size]");
          if (select && select.value !== next) select.value = next;
        }
        if (refreshAfter !== false) {
          document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: { cart: cart } }));
        }
        return cart;
      })
      .catch(function () {
        sizeWriteInFlight = false;
        return null;
      });
  }

  function ensureDefaultSize() {
    var root = document.querySelector("[data-gwp-cart-tiers]");
    if (!root || defaultWriteStarted) return;
    if (root.getAttribute("data-gwp-gloves-unlocked") !== "true") return;
    var current = (root.getAttribute("data-gwp-gloves-size") || "").trim();
    if (current) return;
    defaultWriteStarted = true;
    writeSize("M", true);
  }

  function onSizeChange(event) {
    var select = event.target;
    if (!select || !select.matches || !select.matches("[data-gwp-gloves-size]")) return;
    writeSize(select.value, true);
  }

  function onCartChange(event) {
    var cart = event && event.detail && event.detail.cart;
    var baseEvent = event && event.detail && event.detail.baseEvent;
    if (cart && cart.items) {
      schedulePaint(cart);
      // Impact CartDrawer applies cart:change section HTML after 1250ms.
      // That snapshot can miss Cart Transform item_components right after a
      // qty change, which empties Free Gifts. Re-fetch the drawer section
      // after that delay so CT children come back.
      if (baseEvent === "line-item:change") {
        clearTimeout(onCartChange._ctRefreshTimer);
        onCartChange._ctRefreshTimer = setTimeout(function () {
          document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
        }, 1400);
      }
      return;
    }
    schedulePaint(cart);
    if (!anchorInFlight && !claimInFlight && typeof fetch === "function") {
      fetchCart()
        .then(function (full) {
          schedulePaint(full);
        })
        .catch(function () {});
    }
  }

  function boot() {
    paintAll(null);
    document.addEventListener("change", onSizeChange, true);
    document.addEventListener("cart:change", onCartChange);
    document.addEventListener("cart:refresh", onCartChange);
    function bootAnchor() {
      if (typeof fetch !== "function") return;
      fetchCart()
        .then(function (cart) {
          schedulePaint(cart);
        })
        .catch(function () {});
    }
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        paintAll(null);
        bootAnchor();
      });
    } else {
      bootAnchor();
    }
  }

  boot();

  window.aerobisGwpCartTiers = {
    paint: paintAll,
    resolveState: resolveState,
    placeMarks: placeMarks,
    layoutMarks: layoutMarks,
    shipGateEur: shipGateEur,
    writeSize: writeSize,
    normalizeSize: normalizeSize,
    attribute: ATTR,
    anchorProp: ANCHOR_PROP,
    anchorSku: ANCHOR_SKU,
    anchorHandle: ANCHOR_HANDLE,
    claimProp: CLAIM_PROP,
    giftProp: GIFT_PROP,
    GWP_ANCHOR_VARIANT_ID: GWP_ANCHOR_VARIANT_ID,
    parseVariantId: parseVariantId,
    resolveAnchorVariantId: resolveAnchorVariantId,
    isGwpAnchorItem: isGwpAnchorItem,
    isFreeGiftItem: isFreeGiftItem,
    isClaimItem: isClaimItem,
    isGlovesItem: isGlovesItem,
    isMaskItem: isMaskItem,
    hasFreeGloves: hasFreeGloves,
    hasFreeMask: hasFreeMask,
    merchandiseSubtotalCents: merchandiseSubtotalCents,
    shopEurFromCart: shopEurFromCart,
    collectAnchors: collectAnchors,
    planAnchorSync: planAnchorSync,
    cartStateKey: cartStateKey
  };
})();
